import React from 'react';

function OccBar({ value, size = 'sm' }) {
  const v = Math.round(value || 0);
  const color = v > 70 ? 'var(--ok)' : v > 40 ? 'var(--warn)' : 'var(--danger)';
  const w = size === 'lg' ? 60 : 42;
  const h = size === 'lg' ? 6 : 4;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, direction: 'ltr' }}>
      <div style={{ background: 'var(--surf-alt)', borderRadius: 3, width: w, height: h, overflow: 'hidden', flexShrink: 0 }}>
        <div style={{ background: color, width: `${Math.min(100, v)}%`, height: '100%', borderRadius: 3 }} />
      </div>
      <span style={{ fontSize: 11, color: 'var(--muted)', minWidth: 28, textAlign: 'left' }}>{v}%</span>
    </div>
  );
}

export default OccBar;
